export default {"src":"/uk/_next/static/media/gift.3cdaddc9.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};